import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(
    _,
    {
      inboxId,
      agentList,
      restrictedAgentList = [],
      restrictedWithContactAgentList = [],
    }
  ) {
    return InboxMembersAPI.update({
      inboxId,
      agentList,
      restrictedAgentList,
      restrictedWithContactAgentList,
    });
  },
};

export default {
  namespaced: true,
  actions,
};
